import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import CmsPlaceholder from '..';

export default class Section extends PureComponent {
    static defaultProps = {
        content: {},
    };

    static propTypes = {
        color: PropTypes.string.isRequired,
        plugins: PropTypes.array,
        type: PropTypes.string.isRequired,
        cms: PropTypes.array,
        children: PropTypes.any,
    };

    render() {
        const { type, plugins, cms, color } = this.props;

        const placeholder = {
            type,
            plugins,
            cms,
            sectionFacet: color,
        };

        return (
            <section className={ `cms-section cms-section__${ color }` }>
                <div className="grid--container">
                    { plugins && <CmsPlaceholder placeholder={ placeholder } facet={type} /> }
                    {this.props.children}
                </div>
            </section>
        );
    }
}



// WEBPACK FOOTER //
// ./mcart/assets/src/js/app/components/cms-placeholder/section/index.js